"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const useStyles = (0, styles_1.makeStyles)((theme) => ({
    media: {
        height: 350,
        width: '100%',
        display: 'flex',
        [theme.breakpoints.down('md')]: {
            height: 'auto'
        }
    },
    cardContent: {
        display: 'flex',
        padding: 0,
        height: '100%',
        width: '100%',
        paddingBottom: '0 !important'
    },
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column'
        }
    },
    imageBox: {
        display: 'flex',
        flexDirection: 'row',
        [theme.breakpoints.down('lg')]: {
            flexDirection: 'column'
        }
    },
    image: {
        height: '350px',
        flex: '0 0 auto'
    },
    contentContainer: {
        flex: '1',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        padding: '10px'
    },
    winningNumberContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        [theme.breakpoints.down('md')]: {
            display: 'flex',
            flexWrap: 'wrap'
        },
        paddingBottom: theme.spacing(2)
    },
    winningNumber: {
        border: '1px solid',
        borderRadius: 20,
        width: 40,
        height: 40,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: theme.spacing() / 2,
        [theme.breakpoints.down('md')]: {
            width: 30,
            height: 30
        }
    },
    squareWinningNumber: {
        border: '1px solid',
        borderRadius: 10,
        width: 40,
        height: 40,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: theme.spacing() / 2,
        [theme.breakpoints.down('md')]: {
            width: 30,
            height: 30
        }
    },
    textWinningNumber: {
        width: 40,
        height: 40,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: theme.spacing() / 2,
        [theme.breakpoints.down('md')]: {
            width: 30,
            height: 30
        }
    },
    innerContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        justifyContent: 'center'
    },
    lowerContent: {
        backgroundColor: theme.palette.grey[50]
    },
    gameImageStyle: {
        height: '100%',
        border: '1px solid #dadada',
        [theme.breakpoints.down('md')]: {
            height: '100%'
        }
    },
    extraData: {
        display: 'flex',
        flexDirection: 'row',
        '@media (max-width:600px)': {
            paddingLeft: '60px'
        }
    },
    winningNumberText: {
        textAlign: 'center',
        [theme.breakpoints.down('md')]: {
            fontSize: '12px',
            paddingBottom: theme.spacing(2)
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '12px',
            paddingBottom: 0
        },
        paddingBottom: theme.spacing(2)
    },
    gameLogoStyle: {
        maxHeight: '100px',
        objectFit: 'contain',
        paddingTop: '2em',
        paddingBottom: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
            height: '80px'
        }
    },
    iframe: {
        height: '100%',
        width: '100%',
        maxWidth: '100%',
        paddingTop: theme.spacing() + 1,
        paddingBottom: theme.spacing() + 1,
        [theme.breakpoints.down('md')]: {
            height: '100%',
            width: '100%',
            maxWidth: '100%',
            margin: 0,
            maxHeight: '95%',
            position: 'absolute'
        },
        border: 0
    },
    gameDetailsRevealWatchSDGameCard: {
        [theme.breakpoints.down('md')]: {
            paddingBottom: theme.spacing(4),
            overflow: 'visible'
        },
        [theme.breakpoints.down('sm')]: {
            paddingBottom: theme.spacing(4),
            overflow: 'visible'
        },
        paddingBottom: theme.spacing(2)
    },
    drawNumber: {
        paddingTop: theme.spacing(2)
    },
    detailCardWrapper: {
        paddingRight: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
            paddingRight: 0,
            paddingBottom: theme.spacing(4)
        }
    },
    above: {
        zIndex: 1
    },
    detailContainer: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(2)
    },
    howToPlay: {
        marginTop: theme.spacing(5),
        flexDirection: 'column'
    },
    quickDrawImage: {
        '@media (min-width:1000px)': {
            margin: 5
        }
    },
    quickDrawImageContent: {
        [theme.breakpoints.down('xs')]: {
            paddingLeft: '60px'
        }
    }
}));
exports.default = useStyles;
//# sourceMappingURL=QuickDrawGameCardStyle.js.map